<template>
  <div :class="{ 'oem-bg': isOEM }">
    <div class="main" :class="{'is-oem': isOEM}">

      <ul class="oem-desc" v-if="isOEM">
        <li v-for="(o, i) of oemDescList" :key="i">
          <svg-icon :icon="o.icon" v-if="o.icon"/>
          <div class="wrap" v-else/>
          <strong>{{ o.title }}</strong>
          <p v-for="(p, idx) of o.desc" :key="idx">{{ p }}</p>
          <img :src="o.qrcode" v-if="o.qrcode">
        </li>
      </ul>


      <div class="layout-banner">
        <div class="oem-tag" v-if="$route.path == '/register' && isOEM">
          <svg-icon icon="oem_warn"/>
          选单网CMS为独立开发，请重新注册账号哦~
        </div>
        <div class="layout-inner">
          <slot/>
        </div>
      </div>

      <oem-tongue v-if="isOEM"/>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import OemTongue from '@c/OemTongue'

import qq_kf from '@/images/qq_kf.png'
import oem_preview_qrcode from '@/images/oem_preview_qrcode.png'
export default {
  components: { OemTongue },
  data: () => ({
    oemDescList: [
      { icon: 'oem1', title: '不封域名', desc: ['淘客自营网站，', '独有域名地址'] },
      { icon: 'oem2', title: '沉淀用户', desc: ['手机号一键注册，', '你的客户可以有效留存'] },
      { icon: 'oem3', title: '不会封号', desc: ['微信发单，', '轻松分享，无封号担忧'] },
      { icon: 'oem4', title: '代理、返利、导购', desc: ['三种模式自主选用，', '最适合你的最挣钱'] },
      { icon: 'oem5', title: '微信秒开', desc: ['支持微信一键登录', '免除忘记密码的烦恼'] },
      { icon: 'oem6', title: '支持多种工具', desc: ['公众号、返利机器人', '均可支持，完美结合'] },
      { icon: 'oem7', title: '淘客小程序', desc: ['轻量应用 快速搭建', '多平台领券 便捷下单'] },
      { qrcode: oem_preview_qrcode, title: '在线预览', desc: ['手机扫码', '预览更多'] },
      { qrcode: qq_kf, title: '售后交流', desc: ['QQ扫码加群，', '疑问随时解答'] },
    ]
  }),
  computed: mapGetters([ 'isOEM' ]),
}
</script>

<style lang="scss" scoped>
.main {
  min-height: 800px;
  padding: 108px 72px 0 32px;
  // text-align: right;
  max-width: 1200px;
  margin: 0 auto;
  background-image: url('~@/images/login_bg.png');
  background-repeat: no-repeat;
  background-size: 640px 427.8px;
  background-origin: content-box;
  position: relative;
  display: flex;
  justify-content: flex-end;
}
.layout-banner {
  width: 368px;
  display: inline-block;
  text-align: left;
  // overflow: hidden;
  position: relative;
  margin-left: 88px;
}
.layout-inner {
  padding: 24px 32px;
  width: 100%;
  border-radius: 4px;
  border: 1px solid $theme-border3;
  background: #FFF;
  // position: relative;
  // z-index: 1;
}

.main.is-oem {
  // background-image: url('~@/images/oem_main_bg.png');
  background: none;
  background-size: 640px auto;
}

.oem-desc {
  list-style: none;
  width: 588px;
  height: 438px;
  display: flex;
  flex-wrap: wrap;

  li {
    width: 180px;
    height: 135px;
    background: #FFF;
    margin-right: 16px;
    margin-bottom: 11px;
    border-radius: 4px;
    box-shadow: 0 6px 12px -4px rgba(#909DBC, .26);
    padding: 18px 0 0 12px;
    position: relative;

    .svg-icon {
      display: block;
      width: 35px;
      height: 35px;
      margin-bottom: 11px;
    }
    .wrap {
      height: 35px;
    }
    strong {
      display: block;
      line-height: 22px;
      margin-bottom: 2px;
    }
    p {
      font-size: 12px;
      color: $theme-textsecond;
      line-height: 17px;
    }
    img {
      position: absolute;
      right: 15px;
      bottom: 16px;
      width: 73px;
      height: 73px;
      display: block;
    }
  }
}

.oem-bg {
  background-image: url('~@/images/oem_bg.png'), linear-gradient(to bottom, #F7FBFF, #E4F0FE);
  background-size: auto 100%;
  background-repeat: no-repeat;
  background-position: center center;
  min-height: calc(100vh - 53px);
}

.oem-tag {
  position: absolute;
  top: -20px;
  left: 32px;
  right: 0;
  font-weight: bold;
  padding: 10px;
  color: $theme;
  font-size: 14px;
  color: #FFF;
  background: $theme;
  border-radius: 6px;
  filter:drop-shadow(0 2px 2px rgba(#000, .3));
  &::after {
    content: "";
    position: absolute;
    left: 44px;
    bottom: -5px;
    border: 6px solid $theme;
    border-bottom: none;
    border-left-color: transparent;
    border-right-color: transparent;
    z-index: 0;
  }
  
  .svg-icon {
    width: 18px;
    height: 22px;
    vertical-align: middle;
  }
}
</style>